import React, { useState } from 'react';

// === DUMMY DATA ===
const courses = [
  { title: "Foundation Batch", class: "Class 8th to 10th", subjects: "Maths, Science, English", icon: "📚" },
  { title: "Board Target Batch", class: "Class 11th & 12th", subjects: "PCM / PCB / Commerce", icon: "🎯" },
  { title: "Competitive Exams", class: "JEE / NEET", subjects: "Physics, Chemistry, Maths/Bio", icon: "🚀" }
];

const toppers = [
  { name: "Aarav Sharma", score: "98.5%", exam: "CBSE 12th Boards", img: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=400&auto=format&fit=crop" },
  { name: "Priya Singh", score: "97.2%", exam: "CBSE 10th Boards", img: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=400&auto=format&fit=crop" },
  { name: "Rohan Verma", score: "AIR 452", exam: "JEE Mains", img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=400&auto=format&fit=crop" },
  { name: "Sneha Patel", score: "680/720", exam: "NEET UG", img: "https://images.unsplash.com/photo-1544717305-2782549b5136?q=80&w=400&auto=format&fit=crop" }
];

const testimonials = [
  { text: "My son's math score improved from 60% to 95% in just one year. The teachers pay personal attention to every student.", author: "Mr. Gupta (Parent)" },
  { text: "The regular mock tests and doubt clearing sessions helped me crack JEE in my first attempt. Best coaching in the city!", author: "Rohan Verma (Student)" }
];

// === COMPONENT ===
const CoachingBasic: React.FC = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 4000);
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 font-sans scroll-smooth">
      
      {/* 1. TOP ALERT BAR (For Admission Announcements) */}
      <div className="bg-yellow-500 text-yellow-950 text-xs sm:text-sm font-bold py-2 px-6 text-center tracking-wide">
        🚨 ADMISSIONS OPEN FOR 2026-27 BATCH | FLAT 20% OFF FOR EARLY BIRDS!
      </div>

      {/* 2. NAVBAR */}
      <nav className="bg-white sticky top-0 z-50 shadow-md border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-700 text-white rounded flex items-center justify-center text-xl font-bold">V</div>
            <div className="leading-tight">
              <span className="text-xl font-black text-blue-900 uppercase tracking-tight block">Vidya Classes</span>
              <span className="text-[10px] uppercase tracking-widest text-slate-500 font-bold block">Learn • Grow • Succeed</span>
            </div>
          </div>
          
          <div className="hidden md:flex items-center gap-8 font-bold text-slate-600 text-sm uppercase tracking-wide">
            <a href="#courses" className="hover:text-blue-700 transition">Courses</a>
            <a href="#results" className="hover:text-blue-700 transition">Our Results</a>
            <a href="#contact" className="hover:text-blue-700 transition">Contact Us</a>
          </div>

          <a href="#contact" className="bg-blue-700 text-white px-6 py-2.5 rounded text-sm font-bold uppercase tracking-wider hover:bg-blue-800 transition shadow-lg hidden sm:block">
            Enquire Now
          </a>
        </div>
      </nav>

      {/* 3. HERO SECTION (Focus on Results & Trust) */}
      <header className="bg-blue-900 text-white py-16 lg:py-24 px-6 relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
        
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10">
          <div className="space-y-6 text-center md:text-left">
            <span className="inline-block bg-blue-800 text-blue-200 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest border border-blue-700">
              City's No. 1 Coaching Institute
            </span>
            <h1 className="text-4xl lg:text-6xl font-black leading-tight">
              Shape Your Career With <span className="text-yellow-400">Expert Guidance.</span>
            </h1>
            <p className="text-lg text-blue-200 max-w-lg mx-auto md:mx-0 leading-relaxed">
              We provide highly interactive classes, regular mock tests, and personal doubt-solving sessions to help students achieve their dream scores.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-center md:justify-start">
              <a href="#contact" className="bg-yellow-500 text-blue-950 text-center px-8 py-4 rounded font-black uppercase tracking-widest hover:bg-yellow-400 transition shadow-xl">
                Join Free Demo Class
              </a>
              <a href="#results" className="bg-blue-800 border border-blue-600 text-white text-center px-8 py-4 rounded font-bold uppercase tracking-widest hover:bg-blue-700 transition">
                View Toppers
              </a>
            </div>
          </div>
          <div className="relative h-[400px] lg:h-[500px] rounded-2xl overflow-hidden shadow-2xl border-4 border-blue-800 hidden md:block">
            <img 
              src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=800&auto=format&fit=crop" 
              alt="Students Studying" 
              className="w-full h-full object-cover"
            />
            {/* Floating Badge */}
            <div className="absolute bottom-6 left-6 bg-white p-4 rounded-xl shadow-xl flex items-center gap-4 border-l-4 border-yellow-500">
               <div className="text-blue-900 font-black text-3xl">500+</div>
               <div className="leading-tight">
                 <p className="text-sm font-bold text-slate-800">Students Scored</p>
                 <p className="text-xs text-slate-500 uppercase font-bold">Above 90%</p>
               </div>
            </div>
          </div>
        </div>
      </header>

      {/* 4. WALL OF FAME (Toppers Gallery - Very Important) */}
      <section id="results" className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-blue-600 font-bold uppercase tracking-widest text-sm">Wall of Fame</span>
            <h2 className="text-4xl font-black text-blue-950 mt-2">Our Proud Achievers</h2>
            <p className="text-slate-500 mt-3">Consistent top results year after year.</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {toppers.map((student, idx) => (
              <div key={idx} className="bg-slate-50 rounded-xl p-6 text-center border border-slate-200 hover:shadow-xl transition group">
                <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-4 border-yellow-400 mb-4 group-hover:scale-110 transition-transform">
                  <img src={student.img} alt={student.name} className="w-full h-full object-cover"/>
                </div>
                <h3 className="text-lg font-bold text-blue-950">{student.name}</h3>
                <p className="text-xs text-slate-500 font-semibold mb-2">{student.exam}</p>
                <div className="inline-block bg-green-100 text-green-700 px-3 py-1 rounded text-sm font-black">
                  {student.score}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. COURSES SECTION */}
      <section id="courses" className="py-24 px-6 bg-slate-100 border-y border-slate-200">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-black text-blue-950 mb-4">Courses We Offer</h2>
            <p className="text-slate-500">Expert faculty for every subject to ensure conceptual clarity.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {courses.map((course, idx) => (
              <div key={idx} className="bg-white p-8 rounded-xl border-b-4 border-blue-600 shadow-md hover:-translate-y-2 transition-transform">
                <span className="text-4xl mb-4 block">{course.icon}</span>
                <h3 className="text-xl font-black text-blue-950 mb-2">{course.title}</h3>
                <p className="text-blue-700 font-bold text-sm mb-4">{course.class}</p>
                <p className="text-slate-600 text-sm mb-6 flex items-center gap-2">
                  <span className="text-green-500">✓</span> {course.subjects}
                </p>
                <a href="#contact" className="text-blue-700 font-bold uppercase text-xs tracking-widest hover:text-blue-900 transition">
                  Enquire Now ➔
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 6. TESTIMONIALS */}
      <section className="py-24 px-6 bg-blue-900 text-white text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-black mb-12">What Parents & Students Say</h2>
          <div className="grid md:grid-cols-2 gap-8 text-left">
            {testimonials.map((test, idx) => (
              <div key={idx} className="bg-blue-800 p-8 rounded-xl border border-blue-700 relative">
                <span className="text-6xl text-blue-600 absolute top-2 right-4 font-serif leading-none">"</span>
                <p className="text-blue-100 italic leading-relaxed mb-6 relative z-10">"{test.text}"</p>
                <p className="font-bold text-yellow-400 text-sm uppercase tracking-widest">{test.author}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 7. ADMISSION FORM & CONTACT */}
      <section id="contact" className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Info Side */}
          <div className="space-y-8">
            <h2 className="text-4xl font-black text-blue-950 leading-tight">Start Your Success Journey Today!</h2>
            <p className="text-slate-600">Fill out the enquiry form to get a callback from our admission counselor. You can also book a 2-day free trial class.</p>
            
            <div className="space-y-6 pt-4">
              <div className="flex gap-4 items-center">
                <div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center text-xl font-bold">📍</div>
                <div>
                  <h4 className="font-bold text-blue-950">Our Center</h4>
                  <p className="text-slate-600 text-sm">2nd Floor, City Mall, Sector 15, New Delhi</p>
                </div>
              </div>
              <div className="flex gap-4 items-center">
                <div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center text-xl font-bold">📞</div>
                <div>
                  <h4 className="font-bold text-blue-950">Call Us</h4>
                  <p className="text-slate-600 text-sm">+91 98765 43210 (Mon-Sat, 9AM to 8PM)</p>
                </div>
              </div>
            </div>
          </div>

          {/* Enquiry Form */}
          <div className="bg-slate-50 p-8 sm:p-10 rounded-2xl shadow-xl border border-slate-200">
            <h3 className="text-2xl font-black text-blue-950 mb-6">Admission Enquiry</h3>
            {isSubmitted ? (
              <div className="bg-green-100 border border-green-300 text-green-800 p-8 rounded-xl text-center flex flex-col justify-center items-center h-64">
                <span className="text-5xl mb-4 block">🎉</span>
                <h4 className="font-black text-xl mb-2">Enquiry Sent!</h4>
                <p className="text-sm">Our counselor will contact you within 24 hours.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Student Name</label>
                  <input required type="text" className="w-full bg-white border border-slate-300 px-4 py-3 rounded focus:outline-none focus:border-blue-600 transition" placeholder="Enter Full Name" />
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Parent/Student Mobile</label>
                  <input required type="tel" className="w-full bg-white border border-slate-300 px-4 py-3 rounded focus:outline-none focus:border-blue-600 transition" placeholder="+91 00000 00000" />
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Select Class</label>
                  <select className="w-full bg-white border border-slate-300 px-4 py-3 rounded focus:outline-none focus:border-blue-600 transition text-slate-700">
                    <option>Class 8th - 10th</option>
                    <option>Class 11th - 12th (Science)</option>
                    <option>Class 11th - 12th (Commerce)</option>
                    <option>JEE / NEET Dropper Batch</option>
                  </select>
                </div>
                <button type="submit" className="w-full bg-blue-700 text-white font-black uppercase tracking-widest py-4 rounded hover:bg-blue-800 transition shadow-lg mt-2">
                  Request Callback
                </button>
              </form>
            )}
          </div>

        </div>
      </section>

      {/* 8. FOOTER */}
      <footer className="bg-blue-950 text-blue-200 py-10 px-6 text-center text-sm border-t-4 border-yellow-500">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <span className="text-xl font-bold text-white">V</span>
            <span className="text-lg font-black text-white uppercase tracking-tight">Vidya Classes</span>
          </div>
          <p>© {new Date().getFullYear()} Vidya Classes. All Rights Reserved.</p>
          <p className="text-xs uppercase tracking-widest text-blue-500">Freelance Portfolio Demo</p>
        </div>
      </footer>

    </div>
  );
};

export default CoachingBasic;